import { ComponentRendering } from '@sitecore-jss/sitecore-jss-react';
import { EVENTS_TEMPLATE_ID, EVENT_QUERY_STRINGS, EVENT_TIMELINE_QUERY_VALUE_MAP } from '../../../constants/eventsFairs.constants';
import { TDictionaryField, TIconField, TImageField, TLinkField } from '../../../types/types';
import { TSaveCalendarEventProps } from '../../@shared/saveCalendarEvent/types/saveEvent.types';

export enum EventListingFilters {
  TYPE = 'type',
  TIMELINE = 'timeline',
}

export type TSelectedEventsFilters = Partial<{
  [key in keyof typeof EVENT_QUERY_STRINGS]: string;
}>;

export type TEventsListingItem = Partial<{
  id: string;
  Image: TImageField;
  MobileImage: TImageField;
  video: string;
  useVideo: boolean;
  link: string;
  PrimaryCTA: TLinkField;
  title: string;
  location: string;
  time: string;
  shortDescription: string;
  startDate: string;
  endDate: string;
  calendarDetails?: TSaveCalendarEventProps['calendarDetails'];
  templateId: EVENTS_TEMPLATE_ID;
  templateName: string;
  showDetails: boolean;
  unPublishOn: string;
  eventTimeline: keyof typeof EVENT_TIMELINE_QUERY_VALUE_MAP; // added manually
}>;

export type TEventCardProps = TEventsListingItem & { itemData: TEventsListingItemData };

export type TEventsListingMedia = Partial<{
  desktopImage: TImageField;
  mobileImage: TImageField;
  isDesktop: boolean;
}>;

export type TEventsListingApiData = Partial<{
  items: TEventsListingItem[];
  totalSearchResults: number;
}>;

export type TEventsListingItemData = Partial<{
  contextItemUrl: string;
  thumbnail: string;
  fields: {
    eventIcon: TIconField;
    fairIcon: TIconField;
    liveEventIcon: TIconField;
    hideFilters: TDictionaryField<EventListingFilters>[];
  };
}>;

export type TEventsListingFields = Partial<{
  apiData: TEventsListingApiData;
  isComponentUnreleased?: boolean;
  itemData: TEventsListingItemData;
}>;

export type TEventsListingProps = Partial<{
  fields: TEventsListingFields;
  rendering: ComponentRendering;
}>;
